import { render, staticRenderFns } from "./ReLeadSearchCard.vue?vue&type=template&id=38fd2fba&scoped=true"
import script from "./ReLeadSearchCard.vue?vue&type=script&lang=js"
export * from "./ReLeadSearchCard.vue?vue&type=script&lang=js"
import style0 from "./ReLeadSearchCard.vue?vue&type=style&index=0&id=38fd2fba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fd2fba",
  null
  
)

export default component.exports